module.exports = __webpack_public_path__ + "static/img/patent1.8d8631d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/patent1.png
// module id = hSio
// module chunks = 0